import { useImperativeHandle, useState } from "react";
import { forwardRef, useRef } from "react";
import "./EDisclosure.css";
import { useNavigate, useParams } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";
import LoadingSpinner from "../../components/Controls/LoadingSpinner/LoadingSpinner";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { useSelector } from "react-redux";

const EDisclosure = forwardRef(function Disclaimer({}, ref) {
  const translationsMap = useSelector(
    (state) => state.languageTranslation.translationsMap
  );
  const dialogRef = useRef(null);
  const redirectUrlRef = useRef("");
  const navigate = useNavigate();
  const { documentId, fileName } = useParams();
  const personalInfoRef = useRef(null);
  const showPersonalInfo = useRef(false);
  const level1Dataref = useRef({});
  const countryCodes = useRef({});
  const communicationChannel = useRef({});
  const readerOk = useRef("");
  const docId = useRef("");
  const recipientInfo = useRef({});
  const isAgreed = useRef(false);
  const Reader_LoadingPleaseWait=useRef("");
  const Reader_Disagree=useRef("");
  const Reader_Agree=useRef("");
  const Reader_TermsOfService=useRef("");
  const [openLoader, setOpenLoader] = useState(false);
  const termsofserviceContent=useRef("");
  const [cookie, setCookie]=useState("");
  const isLevel1Var = useRef(false);
  useImperativeHandle(ref, () => {
    return {
      open: (
        showPersonalInfoModal,
        rpdInfoData,
        documentId,
        isLevel1,
        countryCode,
        communication,
        readerOkText,
        reader_LoadingPleaseWait,
        AgreeText,
        DisagreeText,
        TermsOfServiceText,
        content,
        level1Data
      ) => {
        dialogRef.current.showModal();
        showPersonalInfo.current = showPersonalInfoModal;
        communicationChannel.current = communication;
        countryCodes.current = countryCode;
        readerOk.current = readerOkText;
        docId.current = documentId;
        isLevel1Var.current = isLevel1;
        recipientInfo.current = { ...rpdInfoData };
        Reader_LoadingPleaseWait.current = reader_LoadingPleaseWait;
        Reader_Agree.current = AgreeText;
        Reader_Disagree.current = DisagreeText;
        Reader_TermsOfService.current = TermsOfServiceText;
        level1Dataref.current = {...level1Data};
        termsofserviceContent.current=content
        //redirectUrlRef.current = redirectUrl;
      },
    };
  });

  const onAgreedHandler = async () => {
    isAgreed.current = true;
    //window.location.href = redirectUrlRef.current;
    dialogRef.current.close();
    const EDisclosureResponce = await PostEDisclosure();
    if (isLevel1Var.current == false) {
      if (showPersonalInfo.current) {
        personalInfoRef.current.onShow(
          true,
          recipientInfo.current,
          docId.current,
          countryCodes.current,
          communicationChannel.current,
          readerOk.current
        );
      }
      else {
        read(recipientInfo.current.email, recipientInfo.current.recipientId, recipientInfo.current.userSessionId)
      }
    }else{
      localStorage.setItem("local_" + level1Dataref.current.documentId, level1Dataref.current.userSessionId);
          setCookie(level1Dataref.current.documentId, level1Dataref.current.userSessionId);
          sessionStorage.setItem(
            "session_" + level1Dataref.current.documentId,
            level1Dataref.current.userSessionId
          );
          console.log(level1Dataref.current.documentId);
          //history(response.redirectUrl,"_self");
          let localUrl = level1Dataref.current.redirectUrl;

          const slashCount = (localUrl.match(/\//g) || []).length;

          if (slashCount >= 5) {
            const lastSlashIndex = localUrl.lastIndexOf("/");
            localUrl = localUrl.substring(0, lastSlashIndex + 1) + EDisclosureResponce.openRecordId;
          }

          //window.open(localUrl, "_self");
          const redirectPath = new URL(localUrl).pathname;
          navigate(redirectPath, { 
            replace: true,
            state: { 
              translationsMap: {...translationsMap} 
            }
          });
    }
  };

  const onDisagreeHandler = async () => {
    isAgreed.current = false;
    dialogRef.current.close();
    const data = await PostEDisclosure();
    navigate(`/Default/ReaderAccess/${documentId}/${fileName}`);
  };

  const PostEDisclosure = async () => {
    try {
      setOpenLoader(true);
      const response = await fetch(
        `${process.env.REACT_APP_API}/docs/PostEDisclosure/${documentId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...recipientInfo.current,
            eDisclosureAgreed: isAgreed.current,
          }),
        }
      );
      setOpenLoader(false);
      if (!response.ok) {
        throw new Error("Failed to post eDisclosure");
      }
      localStorage.setItem(`EDisclosure_${documentId}_${recipientInfo.current.email}_Agreed`,isAgreed.current)
      return response.json();
    } catch (error) {
      setOpenLoader(false);
      console.log("Error posting eDisclosure:", error);
      return null;
    }
  };

   const read = (email, recipientId, userCookieId) => {
      var url = `${process.env.REACT_APP_API}/docs/read/${documentId}`;
      var rpdInfo = {
        id: documentId,
        email: email,
        recipientId: recipientId,
        data: "",
        ip: recipientInfo.current.ip,
        userSessionId: userCookieId,
      };
  
      setOpenLoader(true);
      fetch(url, {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rpdInfo),
      })
        .then((response) => response.json())
        .then((response) => {
          //console.log(response);
          if (response.authenticated) {
            setOpenLoader(false);
            console.log(documentId);
            console.log(response.recipientId);
            setCookie(
              documentId,
              response.recipientId,
              response.sessionExpireDate
            );
  
            //window.open(response.redirectUrl, "_self");
            const redirectPath = new URL(response.redirectUrl).pathname;
            navigate(redirectPath, { 
              replace: true,
              state: { 
                translationsMap: {...translationsMap} 
              }
            });
          }
        })
        .catch((error) => {
          setOpenLoader(false);
          console.log("Document read error");
        });
    };

  const generatePdf = (action = "save", docBytes = null) => {
    try {
      const titleElement =
        dialogRef.current.querySelector(".disclaimer__title");
      const contentElement =
        dialogRef.current.querySelector(".disclaimer__text");

      if (!titleElement || !contentElement) {
        console.log(
          "Error: Could not find title or content elements in the dialog."
        );
        return;
      }
      const htmlContent = `${contentElement.innerHTML}`;
      const titleContent = titleElement.innerHTML;

      const styleContent = `
        <style>
          body { 
            font-family: "sans-serif";
            padding: 20px;
            max-width: 800px;
            margin: 0 auto;
            word-wrap: break-word;
            white-space: normal;
          }
          h4 { 
            text-align: center;
            margin-bottom: 20px;
            font-size: 18px;
          }
          @media print { 
            body { padding: 0; }
            @page { margin: 0; }
          }
        </style>
      `;

      if (action === "print") {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              ${styleContent}
              <title>${titleContent}</title>
            </head>
            <body>
              <div style="padding: 20px;">
                <h4>${titleContent}</h4>
                ${htmlContent}
              </div>
            </body>
          </html>
        `);
        iframeDoc.close();
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => document.body.removeChild(iframe), 1000);
          }, 500);
        };
      } else if (docBytes) {
        const byteCharacters = atob(docBytes);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${documentId}_Terms of E_Disclosure.pdf`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      console.log(
        `Error ${action === "print" ? "printing" : "downloading"} file:`,
        e
      );
      if (action === "print") window.print();
    }
  };

  const downloadHandler = async () => {
    try {
      setOpenLoader(true);
      const response = await fetch(
        `${process.env.REACT_APP_API}/docs/DownloadEDisclosure/${documentId}`,
        {
          method: "POST",
        }
      );
      setOpenLoader(false);
      if (!response.ok) {
        throw new Error("Failed to download eDisclosure");
      }
      const data = await response.json();
      console.log(data.docBytes);
      generatePdf("save", data.docBytes);
    } catch (error) {
      setOpenLoader(false);
      console.log("Error downloading eDisclosure:", error);
      return null;
    }
  };
  const printHandler = () => generatePdf("print");

  return (
    <>
      {openLoader && (
        <div className="spinerAuth-text ">
          <LoadingSpinner
            authenticatingMsg={translationsMap.Reader_LoadingPleaseWait}
            class={"codeJs"}
          />
        </div>
      )}
      <dialog className="disclaimer " id="disclaimer" ref={dialogRef}>
        <div className="disclaimer__header ">
          <h4 className="disclaimer__title">{translationsMap.Reader_TermsofService}</h4>
          <div className="disclaimer__image-container">
            <span className="material-icons" onClick={downloadHandler}>
              {" "}
              download{" "}
            </span>
            <span className="material-icons" onClick={printHandler}>
              {" "}
              print{" "}
            </span>
          </div>
        </div>
        <div className="disclaimer__content">
          <p
            className="disclaimer__text"
            dangerouslySetInnerHTML={{
              __html: termsofserviceContent.current,
            }}
          />
        </div>
        <div className="disclaimer__footer">
          <button className="disagree py-2" onClick={onDisagreeHandler}>
            {translationsMap.Reader_Disagree}
          </button>
          <button className="agree py-2" onClick={onAgreedHandler}>
           {translationsMap.Reader_Agree}
          </button>
        </div>
      </dialog>
      <PersonalInfo ref={personalInfoRef} />
    </>
  );
});

export default EDisclosure;
